export type PromptCategory =
  | 'system_persona'
  | 'category'
  | 'post_format'
  | 'hook_style'
  | 'dynamic_text'
  | 'image_prompt'
  | 'brand_analysis';

export interface SystemPrompt {
  id: string;
  promptKey: string;
  category: PromptCategory;
  name: string;
  description?: string;
  content: string;
  defaultContent: string;
  variables?: string[];
  isActive: boolean;
  isOverridden: boolean;
  sortOrder: number;
  updatedBy?: string;
  updatedAt?: string;
  createdAt?: string;
}

export interface PromptTestRequest {
  promptKey: string;
  content: string;
  variables?: Record<string, string>;
  testWithAI?: boolean;
}

export interface PromptTestResponse {
  filledPrompt: string;
  aiResponse?: string;
}

export interface PromptVersion {
  id: string;
  promptKey: string;
  content: string;
  changedBy: string | null;
  changedAt: string;
  versionNumber: number;
}
